import {Component, Input} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';

@Component({
  standalone: true,
  selector: 'mc-notification-manager',
  templateUrl: './notification-manager.component.html',
  styleUrls: ['./notification-manager.component.scss'],
  imports: [MatIconModule],
})
export class NotificationManagerComponent {
  @Input() title: string;
  @Input() name: string;
  @Input() email: string;
  @Input() phone: string;
}
